import { toNumber } from "lodash"

export default {

   getStorePrice(data, isAdmin = false){
      const textStart  = isAdmin ? '' : 'Buy for '
      if(data.product_type === 'content_bundle_item') {
         return `${ textStart } ${ data?.bundle_price } USD`
      }

      let result = ''

      if(data.is_multiply_price || data?.options?.length > 1) {
         let min = Infinity;
         let max = -Infinity;

         data?.options?.forEach((item) => {
            const price = toNumber(item.price);
            min = Math.min(min, price);
            max = Math.max(max, price);
         });
         result =  `${ min } - ${ max } USD`
      } else {
         result = data?.options?.[0]?.price + ' USD'
      }


      if(data.product_type === 'priced_by_the_minute') return result + ' per minute'

      return textStart + result
   },

}
